/**
 * Base api path
 *
 * @type {string}
 */

// export const apiPath = 'https://cdn-api.app';
// export const clientSecret = 'pguJuhWDnFmVn9fzZRrkxl2hKCNmSKXKWUoyvg4N';
export const debugMode = true;
//
export const apiPath = 'https://api.portal.viralnewsservice.com';
export const clientSecret = 'pguJuhWDnFmVn9fzZRrkxl2hKCNmSKXKWUoyvg4N';


export const sitePath = 'https://portal.viralnewsservice.com/';
